<template>
  <div class="mlist">
    <div
      v-for="(o, i) in labelTypes"
      class="mlist-item"
      :style="labelToStyle(o)"
      @click="onClickLabelType($event, o)"
      :key="i"
    >
      {{ o.name }}
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ui from "@/store/modules/ui";

export default {
  computed: {
    ...mapState("ui", ["selectedLabelType", "labelTypes"])
  },
  methods: {
    ...mapMutations("ui", ["setLabelType"]),
    labelToStyle(labelObject) {
      let ret = {};
      // shade if selected
      if (labelObject.name == this.selectedLabelType) {
        ret = {
          background: "#dbdbdb"
        };
      } else {
        ret = {
          background: "#fff"
        };
      }

      return { ...ret, borderBottom: `0.5rem solid ${labelObject.bgColor}` };
    },
    onClickLabelType(e, o) {
      this.setLabelType(o.name);
      ui.setAnnoType("placeLabel");
    }
  }
};
</script>

<style lang="scss" scoped>
.mlist {
  border: solid 1px #dbdbdb;
  border-radius: 4px;
  overflow-y: scroll;
  min-height: 0;
}

.mlist-item {
  padding: 0.2rem;
  height: 2.5rem;
  line-height: 1.7rem;
  border-bottom: 1px solid #dbdbdb;
  text-align: left;
  padding-left: 1rem;
  cursor: pointer;

  &:last-child {
    border: none;
  }
}
</style>
